/* eslint-disable no-param-reassign */
const
    calculatePayment = [

        (loanAmount, loanTermMonths, monthlyInterestRate) => {

            loanAmount = parseInt(loanAmount, 10);
            loanTermMonths = parseInt(loanTermMonths, 10);
            monthlyInterestRate = parseFloat(monthlyInterestRate);

            const
                monthlyInterestPayment = (loanAmount * monthlyInterestRate) / 100,
                totalPayment = loanAmount + (monthlyInterestPayment * loanTermMonths),
                monthlyPayment = (totalPayment / loanTermMonths) - (loanAmount / loanTermMonths);

            return parseInt(Math.ceil(monthlyPayment), 10);
        },

        (loanAmount, loanTermMonths, monthlyInterestRate) => {

            loanAmount = parseInt(loanAmount, 10);
            loanTermMonths = parseInt(loanTermMonths, 10);
            monthlyInterestRate = parseFloat(monthlyInterestRate) / 100;

            // eslint-disable-next-line max-len
            const monthlyPayment = (loanAmount * monthlyInterestRate) / (1 - (1 + monthlyInterestRate) ** -loanTermMonths);

            return Math.ceil(monthlyPayment);
        },
    ],
    numberFormatter = new Intl.NumberFormat('ru-RU'),
    formatSuffix = (value, suffix) => {

        // eslint-disable-next-line no-param-reassign
        value = parseInt(value, 10);
        if (value > 10 && value < 21)
            return suffix[2];

        // eslint-disable-next-line no-param-reassign
        value = parseInt(value.toString().slice(-1), 10);
        if (value === 1)
            return suffix[0];

        if (value > 1 && value < 5)
            return suffix[1];

        return suffix[2];
    },
    formatDate = (date) => {

        const
            months = [ 'января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря' ],
            month = date.getMonth(),
            monthFormatted = months[month];

        return `${date.getDate()} ${monthFormatted} ${date.getFullYear()}`;
    };

document
    .querySelectorAll('[data-application]')
    .forEach((widget) => {

        const
            applications = widget.querySelectorAll('[data-application-id]'),
            rate = widget.dataset.applicationRate,
            amountInput = widget.querySelector('[name="amount"]'),
            termInput = widget.querySelector('[name="term"]'),
            paymentElement = widget.querySelector('[data-application-payment]'),
            maxElement = widget.querySelector('[data-range="term"] [data-range-max]'),
            firstApplicationDescText = widget.querySelector('[data-application-id="0"]').dataset.template,
            firstApplicationDescElement = widget.querySelector('[data-application-id="0"] [data-application-description]'),
            recalculatePayment = () => {

                const lastPaymentDate = new Date();
                lastPaymentDate.setMonth(lastPaymentDate.getMonth() + parseInt(termInput.value, 10));

                firstApplicationDescElement.innerText = firstApplicationDescText
                    .replace('{date}', formatDate(lastPaymentDate))
                    .replace('{amount}', numberFormatter.format(amountInput.value));

                paymentElement.innerText = calculatePayment[widget.querySelector('[data-active="1"]').dataset.applicationId](amountInput.value, termInput.value, rate);
            };

        amountInput.addEventListener('change', recalculatePayment);
        termInput.addEventListener('change', recalculatePayment);

        applications.forEach((application) => {

            application.addEventListener('click', () => {

                applications.forEach((el) => {
                    el.dataset.active = 0;
                });

                application.dataset.active = 1;
                application.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

                const
                    maxTerm = application.dataset.applicationMaxTerm,
                    suffix = maxElement.dataset.rangeSuffix.split('|');

                termInput.max = maxTerm;
                if (termInput.value > maxTerm)
                    termInput.value = maxTerm;

                termInput.dispatchEvent(new Event('input'));
                termInput.dispatchEvent(new Event('change'));

                maxElement.innerText = `${maxTerm} ${formatSuffix(maxTerm, suffix)}`;

                recalculatePayment();
            });
        });

        if (window.matchMedia && window.matchMedia('all and (max-width: 776px)').matches) {

            let timeoutApplication = null;
            setTimeout(() => {

                document.addEventListener('scroll', () => {

                    clearTimeout(timeoutApplication);
                    timeoutApplication = setTimeout(() => {

                        timeoutApplication = null;

                        const
                            boundingBox = widget.getBoundingClientRect(),
                            button = widget.querySelector('[data-sticky-button]');

                        document.body.style.setProperty('padding-bottom', `${button.offsetHeight}px`);

                        // eslint-disable-next-line max-len
                        if (boundingBox.bottom + window.innerHeight <= (window.innerHeight || document.documentElement.clientHeight))
                            button.dataset.fixed = 1;
                        else
                            button.removeAttribute('data-fixed');


                    }, 50);
                });
            }, 100);
        }
    });

document
    .querySelectorAll('[data-range]')
    .forEach((container) => {

        const
            range = container.querySelector('input[type="range"]'),
            rangeValue = container.querySelector('[data-range-value]'),
            rangeSuffix = container.querySelector('[data-range-suffix]'),
            suffixes = rangeSuffix.dataset.rangeSuffix.split('|');

        range.addEventListener('input', () => {

            const perPercent = (range.max - range.min) / 100;

            range.style.setProperty('--percent', `${(range.value - range.min) / perPercent}%`);
            rangeValue.innerText = numberFormatter.format(range.value);
            if (suffixes.length > 1)
                rangeSuffix.innerText = formatSuffix(range.value, suffixes);
        });
    });